module.exports = "<svg preserveAspectRatio=\"none\" viewBox=\"0 0 971.1 561.8\"><path fill=\"#B6B1A5\" d=\"M0 0l84.3 561.8L856 500.7 971.1 64.2z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./svgs/skew-box-swiper.svg
// module id = 318
// module chunks = 1